<template>
  <div v-if="hasSocial" class="pv4">
    <h4 class="f3 near-black mb4">Elsewhere</h4>
    <ul class="list pa0 ma0">
      <li v-if="proUser.twitterUsername">
        <a :href="'http://www.twitter.com/' + proUser.twitterUsername" class="teal link hover-teal lh-copy f3" target="_blank">Twitter</a>
      </li>
      <li v-if="proUser.instagramUsername">
        <a :href="'http://www.instagram.com/' + proUser.instagramUsername" class="teal link hover-teal lh-copy f3" target="_blank">Instagram</a>
      </li>
      <li v-if="proUser.facebookUsername">
        <a :href="'http://www.facebook.com/' + proUser.facebookUsername" class="teal link hover-teal lh-copy f3" target="_blank">Facebook</a>
      </li>
    </ul>
  </div>
</template>
<script>
  export default {
    name: 'ProProfileSocial',
    props: {
      proUser: {
        type: Object,
        required: true,
      },
    },
    computed: {
        hasSocial: function() {
            return this.proUser.twitterUsername || this.proUser.facebookUsername || this.proUser.instagramUsername;
        },
    },
  };
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/main/frontend/vue/js/modules/pro/profile/components/ProProfileSocial.vue